const layout4 = `
    <div class="bg-[#F5F5F4] py-5 md:py-16">
                <div class="container mx-auto px-[15px] max-w-[1240px]">
                    <div class="space-y-5 md:space-y-[64px]">
                        <div>
                            <h3 class="text-[24px] sm:text-left md:text-center text-stone-950 font-nunito font-medium leading-[32px] mb-3 md:mb-[24px]">
                                Easy Steps to Enjoy Journey
                            </h3>
                            <div class="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-6">
                                <div class="bg-red-100 w-full p-4 rounded-[10px] shadow-sm">
                                    <div class="flex items-center gap-2">
                                        <span class="text-[48px] text-red-600 font-nunito font-medium leading-[100%]">
                                            1
                                        </span>
                                        <span class="text-[18px] text-red-600 font-nunito font-semibold leading-[24px]">
                                            Search Destination
                                        </span>
                                    </div>
                                    <p class="text-[14px] text-stone-800 font-nunito font-normal leading-[24px] mt-2">
                                        Enjoy discounts at participating
                                        properties worldwide
                                    </p>
                                </div>
                                <div class="bg-red-100 w-full p-4 rounded-[10px] shadow-sm">
                                    <div class="flex items-center gap-2">
                                        <span class="text-[48px] text-red-600 font-nunito font-medium leading-[100%]">
                                            2
                                        </span>
                                        <span class="text-[18px] text-red-600 font-nunito font-semibold leading-[24px]">
                                            Select Ticket!
                                        </span>
                                    </div>
                                    <p class="text-[14px] text-stone-800 font-nunito font-normal leading-[24px] mt-2">
                                        Enjoy discounts at participating
                                        properties worldwide
                                    </p>
                                </div>
                                <div class="bg-red-100 w-full p-4 rounded-[10px] shadow-sm">
                                    <div class="flex items-center gap-2">
                                        <span class="text-[48px] text-red-600 font-nunito font-medium leading-[100%]">
                                            3
                                        </span>
                                        <span class="text-[18px] text-red-600 font-nunito font-semibold leading-[24px]">
                                            Pay and Enjoy your Journey!
                                        </span>
                                    </div>
                                    <p class="text-[14px] text-stone-800 font-nunito font-normal leading-[24px] mt-2">
                                        Enjoy discounts at participating
                                        properties worldwide
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
                                <div class="col-span-auto">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-1.png"
                                        width="100%"
                                        height="auto"
                                        alt="img-1"
                                    />
                                </div>
                                <div class="col-span-auto">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-2.png"
                                        width="100%"
                                        height="auto"
                                        alt="img-2"
                                    />
                                </div>
                                <div class="col-span-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-3.png"
                                        width="100%"
                                        height="auto"
                                        alt="img-3"
                                    />
                                </div>
                                <div class="col-span-2">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-4.png"
                                        width="100%"
                                        height="auto"
                                        alt="img-4"
                                    />
                                </div>
                                <div class="col-span-auto">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-5.png"
                                        width="100%"
                                        height="auto"
                                        alt="img-5"
                                    />
                                </div>
                                <div class="col-span-auto">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/bus-operator-6.png"
                                        width="100%"
                                        height="auto"
                                        alt="img-6"
                                    />
                                </div>
                            </div>
                        </div>

                        <div>
                            <h3 class="text-[24px] sm:text-left md:text-center text-stone-950 font-nunito font-medium leading-[32px] mb-[24px]">
                                Why book with us?
                            </h3>
                            <div class="grid xs:grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-6">
                                <div class="bg-red-100 flex gap-4 p-4 rounded-[10px]">
                                    <div class="w-[50px] mt-[15px]">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/best-price.svg"
                                            width="40"
                                            height="41"
                                            alt="best-price"
                                        />
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <h5 class="text-base md:text-lg text-red-600 font-nunito font-semibold">
                                            Best Prices
                                        </h5>
                                        <p class="text-[14px] text-stone-800 font-nunito font-normal leading-[24px]mt-2">
                                            Enjoy discounts at participating
                                            properties worldwide
                                        </p>
                                    </div>
                                </div>
                                <div class="bg-red-100 flex gap-4 p-4 rounded-[10px]">
                                    <div class="w-[40px] mt-[15px]">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/secured-payment.svg"
                                            width="40"
                                            height="41"
                                            alt="secured-payment"
                                        />
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <h5 class="text-base md:text-lg text-red-600 font-nunito font-semibold">
                                            Secured Payment
                                        </h5>
                                        <p class="text-[14px] text-stone-800 font-nunito font-normal leading-[24px]mt-2">
                                            Enjoy discounts at participating
                                            properties worldwide
                                        </p>
                                    </div>
                                </div>
                                <div class="bg-red-100 flex gap-4 p-4 rounded-[10px]">
                                    <div class="w-[50px] mt-[10px]">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/refund-white.svg"
                                            width="40"
                                            height="41"
                                            alt="refund"
                                        />
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <h5 class="text-base md:text-lg text-red-600 font-nunito font-semibold">
                                            Easy Returns
                                        </h5>
                                        <p class="text-[14px] text-stone-800 font-nunito font-normal leading-[24px]mt-2">
                                            Enjoy discounts at participating
                                            properties worldwide
                                        </p>
                                    </div>
                                </div>
                                <div class="bg-red-100 flex gap-4 p-4 rounded-[10px]">
                                    <div class="w-[50px] mt-[10px]">
                                        <img
                                            src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/24-hours.svg"
                                            width="40"
                                            height="41"
                                            alt="clock"
                                        />
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <h5 class="text-base md:text-lg text-red-600 font-nunito font-semibold">
                                            24/7 Support
                                        </h5>
                                        <p class="text-[14px] text-stone-800 font-nunito font-normal leading-[24px]mt-2">
                                            Enjoy discounts at participating
                                            properties worldwide
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="grid sm:grid-cols-1 lg:grid-cols-2 gap-5 md:gap-[56px]">
                                <div class="w-full order-last md:order-first">
                                    <img
                                        src="${process.env.MIX_REACT_APP_STATIC_CONTENT_BASE_URL}/web-template-images/about-us.png"
                                        width="100%"
                                        height="auto"
                                        alt="bus"
                                    />
                                </div>
                                <div class="w-full">
                                    <h2 class="text-[24px] md:text-[48px] text-stone-800 font-nunito font-medium leading-[100%] mb-1 md:mb-5">
                                        About Us
                                    </h2>
                                    <p class="text-sm md:text-base text-stone-800 font-nunito font-normal leading-6 mb-3 md:mb-[28px]">
                                        Shyamoli Paribahan is a traditional name
                                        in the road transport world of
                                        Bangladesh. When Bangladesh was emerging
                                        as a country after independence, Ramesh
                                        Chandra Ghosh engaged in passenger
                                        transport services in 1973 and started
                                        Shyamoli Paribahan from his district
                                        town Pabna.
                                        <br /> <br />
                                        Starting with 1 bus, now Shyamli has one
                                        of the largest bus fleets in the country
                                        with around 500 AC/Non-AC luxury chair
                                        coach buses.
                                    </p>
                                    <button class="bg-red-600 text-white text-base text-semibold leading-[24px] rounded-[8px] px-4 py-2">
                                        Book Tickets
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;

export default layout4;
